import React from 'react';

interface TextLinkProps extends React.AnchorHTMLAttributes<HTMLAnchorElement> {
  children: React.ReactNode;
  variant?: 'primary' | 'secondary';
  href?: string;
  target?: string;
}

export function TextLink({
  children,
  variant = 'primary',
  className = '',
  href,
  target,
  ...props
}: TextLinkProps): JSX.Element {
  const baseStyles =
    'text-left text-gray-900 hover:text-blue-600 hover:underline';
  const variantStyles = {
    primary: '',
    secondary: 'text-gray-500',
  };

  return (
    <a
      href={href}
      target={target}
      className={`${baseStyles} ${variantStyles[variant]} ${className}`}
      {...props}
    >
      {children}
    </a>
  );
}
